var render = function render(){var _vm=this,_c=_vm._self._c;return _c('productList',{ref:"productList",attrs:{"loading":_vm.loading,"finished":_vm.finished},on:{"moreClick":_vm.moreClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }